import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { authService } from '../services/authService';

export default function ProtectedRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Verifica autenticação ao montar componente
    const isAuthenticated = authService.checkAuth();
    
    if (isAuthenticated) {
      setIsChecking(false);
    }
    // Se não autenticado, checkAuth() já redirecionou para login
  }, []);

  // Mostra loading enquanto verifica autenticação
  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Verificando autenticação...</p>
      </div>
    );
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
